import { WebSocketInstanceService } from './web.socket.instance.service';
import { WebSocketInstanceNoopService } from './web.socket.instance.noop.service';
import { IWebSocketInstance } from './web.socket.instance.interface';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { MsalInterceptor } from '../../../msal/msal.interceptor';
import { Injectable } from '@angular/core';
import { WebSocketConfigService } from './web.socket.config.service';
import { WebSocketLoggerService } from './web.socket.logger.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private instance: IWebSocketInstance;

  constructor(
    private readonly msalInterceptor: MsalInterceptor,
    private readonly config: WebSocketConfigService,
    private readonly logger: WebSocketLoggerService,
  ) {}

  public getOrCreateInstance(): Observable<IWebSocketInstance> {
    let instance: IWebSocketInstance;
    if (this.instance) {
      instance = this.instance;
    } else {
      this.logger.log('WebSocketService', 'Creating new instance');
      if (this.config.isEnabled) {
        instance = new WebSocketInstanceService(this.config.url, this.msalInterceptor, this.logger, this.config);
      } else {
        this.logger.warn('WebSocketService', 'WebSocket disabled, using noop implementation');
        instance = new WebSocketInstanceNoopService();
      }
      this.instance = instance;
    }
    return instance.isConnected.pipe(
      filter((isConOpened) => isConOpened),
      take(1),
      map(() => instance)
    );
  }
}










